import React from 'react';
import PropTypes from 'prop-types';
import overlayStyles from '../../styles/inputfield.module.css'
import { Button } from 'react-bootstrap';

const InputField = ({
                      id,
                      required,
                      value,
                      placeholder,
                      onChange,
                      label,
                      readOnly,
                      disabled,
                      rightBtn,
                      rightBtnClick,
                      maxlength,
                      minlength,
                      type,
                      showErrorMessage,
                      errorMessage,
                      inputRef,
                      wrapperStyle,
                      inputMode,
                      autoComplete,
                    }) => {
  return (
    <div className={overlayStyles['styled-input-wrapper']} style={{...wrapperStyle}}>
      <input
      className={overlayStyles['styled-animated-input']}
        type={type?type:"text"}
        id={id}
        value={value}
        placeholder={placeholder}
        inputMode={inputMode}
        autoComplete={autoComplete}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        readOnly={readOnly}
        disabled={disabled}
        maxLength={maxlength}
        minLength={minlength}
        ref={inputRef ? inputRef : null}
        onKeyDown={(e) => type==="number" && ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
      />
      <label className={overlayStyles['styled-label']}htmlFor={id}>
        {label}
      </label>
      {
        showErrorMessage &&
        <span className={overlayStyles['error-text']}>{errorMessage}</span>
      }
      {rightBtn ? (
        <Button className={overlayStyles['styled-button']}
          onClick={rightBtnClick}
        >
          Edit
        </Button>
      ) : null}
    </div>
  );
}

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  rightBtn: PropTypes.bool,
  rightBtnClick: PropTypes.func,
};

InputField.defaultProps = {
  label: '',
  required: false,
  readOnly: false,
  disabled: false,
  rightBtn: false,
  rightBtnClick: undefined,
};

export default InputField;
